import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0737c460"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "list" }

import { onMounted, onUnmounted, ref } from "vue";
import {
  getChain,
  getTxs,
  getValidators,
  getBlocks,
  getChainStatistics,
} from "@/api/_common";
import { Chain, Transaction, Block, Validators } from "@/api/api";
import Search from "./search.vue";
import LatestBlockList from "./blockList.vue";
import LatestTxList from "./txList.vue";
import Summary from "./summary.vue";
import HelperTools from "@/utils/helper";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const chainInfo = ref<Chain>({});
const txs = ref<Transaction>({});
const blocks = ref<Block>({});
const validators = ref<Validators>({});
const blockShowTime = ref<number[]>([]);
const transactionShowTime = ref<number[]>([]);
const totalAddresses = ref(0);
const totalNfts = ref(0);

const _getChain = async () => {
  const res = await getChain();
  if (res) {
    chainInfo.value.Height = res.Height;
  }
};
const _getTxs = async () => {
  const res = await getTxs({
    PageNo: 0,
    PageSize: 6,
  });
  if (res) {
    txs.value = res;
    transactionShowTime.value = txs.value.Transactions.map((t) =>
      HelperTools.getDateTime(t.Time)
    );
  }
};
const _getBlocks = async () => {
  const res = await getBlocks({
    PageNo: 0,
    PageSize: 6,
  });
  if (res) {
    blocks.value = res;
    blockShowTime.value = blocks.value.Blocks.map((b) =>
      HelperTools.getDateTime(b.Time)
    );
  }
};
const _getValidators = async () => {
  const res = await getValidators({
    PageNo: 0,
    PageSize: 10,
  });
  if (res) {
    validators.value = res;
  }
};
const _getChainStatistics = async () => {
  const res = await getChainStatistics();
  if (res) {
    totalAddresses.value = res.TotalAddresses;
    totalNfts.value = res.TotalNfts;
  }
};

const increaseShowTime = () => {
  blockShowTime.value = blockShowTime.value.map((t) => t + 1);
  transactionShowTime.value = transactionShowTime.value.map((t) => t + 1);
};

const load = () => {
  _getChain();
  _getTxs();
  _getBlocks();
  _getValidators();
  _getChainStatistics();
};
load();

let intervalId;
let counter = 0;
onMounted(() => {
  intervalId = setInterval(() => {
    counter = counter + 1;
    if (counter % 10 === 0) {
      load();
    } else {
      increaseShowTime();
    }
  }, 1000);
});
onUnmounted(() => {
  clearInterval(intervalId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Search),
    _createVNode(Summary, {
      height: chainInfo.value.Height,
      validator: validators.value.TotalCount,
      tx: txs.value.TotalCount,
      nft: totalNfts.value,
      holder: totalAddresses.value
    }, null, 8, ["height", "validator", "tx", "nft", "holder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LatestBlockList, {
        blocks: blocks.value.Blocks,
        showTime: blockShowTime.value
      }, null, 8, ["blocks", "showTime"]),
      _createVNode(LatestTxList, {
        transactions: txs.value.Transactions,
        showTime: transactionShowTime.value
      }, null, 8, ["transactions", "showTime"])
    ])
  ]))
}
}

})